import { getExerciseResultsFromZone } from '../utils/getExerciseResultsFromZone.js';
import { getExerciseResultsBlocks } from '../utils/getExerciseResultsBlocks.js';
import { getExerciseResultsData } from '../utils/getExerciseResultsData.js';
import { getExerciseBlocks } from '../utils/getExerciseBlocks.js';

export default (exerciseData, images, submission) => ({
  researchBlocks: null,
  resultsBlocks: null,
  resultsData: null,
  studentName: submission.studentName,
  init() {
    this.researchBlocks = getExerciseBlocks(exerciseData["research"]);
    this.resultsBlocks = getExerciseResultsBlocks(this.researchBlocks);
    const data = {
      research: submission.researchData
    };
    this.resultsData = getExerciseResultsData(this.resultsBlocks, data, images);
  },
  getResultsFromZone(zone) {
    return getExerciseResultsFromZone(zone, this.resultsData);
  },
});
